import { themes, Head, Notes } from 'mdx-deck';
import Compare from "../../../../../../static/mwdj_0301.png";
import React from 'react';
export default {
  themes: themes,
  Head: Head,
  Notes: Notes,
  Compare: Compare,
  React: React
};